import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col, Spinner } from 'reactstrap';
import SimpleBar from 'simplebar-react';

//Import images
import avatar3 from '../../../assets/images/users/avatar-3.jpg';
import avatar4 from '../../../assets/images/users/avatar-4.jpg';

//i18n
import { withTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getAllUnreadNotificationLoading } from 'store/actions';
import moment from 'moment';
import { markAsReadNotification } from 'store/notifications/helper';

const AlertMessageDropdown = props => {
	// Declare a new state variable, which we'll call "menu"
	const [menu, setMenu] = useState(false);
	const [notificationData, setNotificationData] = useState([]);
	const [unreadCount, setUnreadCount] = useState(0);
	const [isLoading, setIsLoading] = useState(false);

	const NotificationProperties = createSelector(
		state => state.Notifications,
		notifications => ({
			unreadMessageLoading: notifications.unread_notification_loading,
			unreadMessageData: notifications.unread_notification_data
		})
	);

	const { unreadMessageLoading, unreadMessageData } = useSelector(NotificationProperties);

	const dispatch = useDispatch();

	useEffect(() => {
		if (unreadMessageData && unreadMessageData.total) {
			setUnreadCount(unreadMessageData.total);
			setNotificationData(unreadMessageData.unread);
			setIsLoading(false);
		} else {
			setUnreadCount(0);
			setNotificationData([]);
			setIsLoading(false);
		}
	}, [unreadMessageData]);

	useEffect(() => {
		setIsLoading(true);
		dispatch(getAllUnreadNotificationLoading());
	}, []);

	const markAsRead = id => {
		setIsLoading(true);
		markAsReadNotification(id)
			.then(res => {
				setNotificationData([]);
				dispatch(getAllUnreadNotificationLoading());
			})
			.catch(err => {});
	};
	return (
		<React.Fragment>
			<Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className="dropdown d-inline-block" tag="li">
				<DropdownToggle
					className="btn header-item noti-icon position-relative"
					tag="button"
					id="page-header-notifications-dropdown"
				>
					<i className={unreadCount > 0 ? 'bx bx-chat bx-tada' : 'bx bx-bell'} />
					<span className="badge bg-danger rounded-pill">{unreadCount}</span>
				</DropdownToggle>

				<DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
					<div className="p-3">
						<Row className="align-items-center">
							<Col>
								<h6 className="m-0"> {props.t('Notifications')} </h6>
							</Col>
							<div className="col-auto">
								<Link to={`/notifications`} onClick={() => setMenu(!menu)} href="#" className="small">
									View All
								</Link>
							</div>
						</Row>
					</div>
					{(isLoading || unreadMessageLoading) && (
						<div className="mt-5 text-center vertical-center text-primary" style={{ height: '200px' }}>
							<Spinner />
						</div>
					)}
					{!isLoading && !unreadMessageLoading && notificationData && notificationData.length == 0 && (
						<div className="mt-5 text-center vertical-center" style={{ height: '200px' }}>
							<h5 className="m-0 font-size-12">No Notification Found.</h5>
						</div>
					)}
					{!isLoading && notificationData.length > 0 && (
						<SimpleBar style={{ height: '230px' }}>
							{notificationData.map((data, index) => {
								return (
									<Link to="" className="text-reset notification-item" key={index}>
										<div className="d-flex">
											<div className="flex-grow-1">
												<h6 className="mt-0 mb-1 font-size-12">
													{data.notificationPage} : {data.notificationPageId}
												</h6>
												<div className="font-size-11 text-muted">
													<p className="mb-1">{data.message}</p>
													<p className="mb-0 font-size-10">
														<i className="mdi mdi-clock-outline" /> at {moment(data.createdOn).format('lll')} By{' '}
														{data.senderName}
													</p>
												</div>
												<div className="mt-2">
													{/* View Booking and Mark as read button */}

													<Link
														to={`/booking-details/${data.notificationPageId}`}
														className="btn btn-primary btn-sm btn-block me-2"
														onClick={() => setMenu(!menu)}
													>
														View Booking
													</Link>
													<button
														className="btn btn-secondary btn-sm btn-block"
														onClick={() => {
															markAsRead(data?._id);
														}}
													>
														Mark as Read
													</button>
												</div>
											</div>
										</div>
									</Link>
								);
							})}
						</SimpleBar>
					)}

					{!isLoading && notificationData.length > 0 && (
						<div className="p-2 border-top d-grid">
							<Link
								className="btn btn-sm btn-link font-size-14 text-center"
								to={`/notifications`}
								onClick={() => setMenu(!menu)}
							>
								<i className="mdi mdi-arrow-right-circle me-1"></i>{' '}
								<span key="t-view-more">{props.t('View More..')}</span>
							</Link>
						</div>
					)}
				</DropdownMenu>
			</Dropdown>
		</React.Fragment>
	);
};

export default withTranslation()(AlertMessageDropdown);

AlertMessageDropdown.propTypes = {
	t: PropTypes.any
};
